import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useWorkout } from '../context/WorkoutContext';
import { soundManager } from '../utils/SoundManager';
import './FixedNextHelper.css';

/**
 * A fixed floating action button that handles workout navigation.
 * This button advances to the next exercise or completes the workout.
 *
 * @param {Object} props - Component props
 * @param {Function} props.onClick - Optional additional action to perform
 * @param {string} props.className - Additional CSS classes for customization
 * @param {React.CSSProperties} props.style - Additional inline styles
 */
const FixedNextHelper = ({
                             onClick,
                             className = '',
                             style = {}
                         }) => {
    const navigate = useNavigate();
    const { state, actions, computed } = useWorkout();
    const { repCount } = state;
    const currentExercise = computed.currentExercise;
    const isLastExercise = computed.isLastExercise;

    const handleClick = () => {
        // 🎵 PLAY NEXT BUTTON SOUND
        soundManager.playButtonSound();

        // Execute any additional onClick prop first
        if (onClick) {
            onClick();
        }

        // Handle the workout navigation
        handleNextExercise();
    };

    const handleNextExercise = () => {
        // Complete the current exercise with pre-set rep count
        actions.completeReps(currentExercise, repCount);

        // If it's the last exercise, go to workout complete
        if (isLastExercise) {
            actions.completeWorkout();
            navigate('/workout-complete');
        } else {
            // Otherwise, move to the next exercise
            actions.nextExercise();
        }
    };

    return (
        <div className={`fixed-next-helper ${className}`} style={style}>
            <button
                className="floating-action-button"
                onClick={handleClick}
                aria-label="Next"
                title="Next Exercise"
            >
                <svg
                    className="arrow-icon"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M8.91003 19.92L15.43 13.4C16.2 12.63 16.2 11.37 15.43 10.6L8.91003 4.08"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            </button>
        </div>
    );
};

export default FixedNextHelper;